import { SITE } from "../config/site";

const QUESTIONS = [
  {
    q: "Where is Petrah Collection located?",
    a: `${SITE.locationTitle}, ${SITE.locationLine}.`,
  },
  {
    q: "How can I place an order?",
    a: "You can order directly on the website, then confirm through WhatsApp, or contact the shop by phone for quick help.",
  },
  {
    q: "What payment methods do you accept?",
    a: "We support cash, M-Pesa, bank transfer, and WhatsApp-assisted order confirmation depending on what works best for you.",
  },
  {
    q: "How do I contact the shop?",
    a: `Call ${SITE.phoneDisplay}, email ${SITE.email}, or reach out through Instagram and TikTok links listed on the site.`,
  },
];

export default function FAQs() {
  return (
    <main className="mx-auto max-w-5xl px-4 py-10 sm:px-6 lg:px-8">
      <div className="rounded-[2rem] border border-slate-200 bg-white p-6 shadow-sm sm:p-8">
        <p className="text-xs font-semibold uppercase tracking-[0.25em] text-[#e46a2e]">FAQs</p>
        <h1 className="mt-2 text-3xl font-black tracking-tight text-slate-950">Common questions from shoppers</h1>
        <div className="mt-6 space-y-4">
          {QUESTIONS.map((item) => (
            <div key={item.q} className="rounded-[1.5rem] border border-slate-200 bg-slate-50 p-5">
              <h2 className="text-lg font-bold text-slate-950">{item.q}</h2>
              <p className="mt-2 text-sm leading-6 text-slate-600">{item.a}</p>
            </div>
          ))}
        </div>
      </div>
    </main>
  );
}